var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17.863,
    viewBox: "0 0 19 17.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35486",
    "data-name": "\\u8DEF\\u5F84 35486",
    className: "cls-1",
    d: "M77.563,3.842h-.451a.687.687,0,0,1-.651-.522,4.365,4.365,0,0,0-8.44,0,.687.687,0,0,1-.649.522h-.049a4.38,4.38,0,0,0-4.381,4.38v5.334a4.38,4.38,0,0,0,4.381,4.38h10.24a4.379,4.379,0,0,0,4.38-4.38V8.222a4.379,4.379,0,0,0-4.38-4.38m-7.6-1.022a2.78,2.78,0,0,1,4.559,0,.662.662,0,0,1-.563,1.022H70.524a.661.661,0,0,1-.562-1.022m7.891,7.485a2.606,2.606,0,0,1-4.186,1.635l-4.3,2.219a1.324,1.324,0,1,1-1.129-2.394l4.447-1.908c0-.049-.008-.1,0-.145A2.607,2.607,0,0,1,75.46,7.292a2.54,2.54,0,0,1,1.142.365l0,0a.288.288,0,0,1-.029.5l-.968.457a1.008,1.008,0,0,0-.488,1.325,1.027,1.027,0,0,0,1.371.489l.955-.451a.288.288,0,0,1,.41.286c0,.015,0,.027,0,.036",
    transform: "translate(-62.942 -0.072)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIcon);
export default __webpack_public_path__ + "static/media/tools-icon.14ee3af4e3dfd56136eb9c53dc1d99fc.svg";
export { ForwardRef as ReactComponent };